import { ProfileType } from '../enums/ProfileType';

export class User {
  id: number = 0;
  name: string = '';
  email: string = '';
  createdAt: Date = new Date();
  updatedAt?: Date;
  profileType?: ProfileType;
  locations?: string;
  token?: string | null;
  sessionExpiresAtUtcDate?: Date;
  sessionExpiresAtAmericaSaoPauloDate?: Date;
  canToggleAutoInvoice?: boolean;
}